import { createApi } from '@reduxjs/toolkit/query/react';
import { restBaseQuery } from '../../api/rest/baseQuery';
import { appConfiguration } from '../../configuration/appConfiguration';

const tagsSlice = createApi({
  reducerPath: 'tagsApi',
  baseQuery: restBaseQuery(appConfiguration.rioTags.api.url),
  endpoints: (build) => ({
    getTags: build.query<any, void>({
      query: () => ({ url: '/tags' }),
    }),
  }),
});

export const {
  reducer: tagsReducer,
  reducerPath: tagsReducerPath,
  middleware: tagsMiddleware,
  useGetTagsQuery,
} = tagsSlice;
